/**
 * BioGold Customer Reviews — light Judge.me DOM enhancer for Figma layout.
 * Runs after the widget HTML is present (legacy metafield or hydrated widget).
 * Photo lightbox is left to Judge.me’s native modal.
 */
(function () {
  const SECTION_SEL = '[data-section-type="customer-reviews"]';
  const ENHANCED = 'm-customer-reviews--enhanced';
  const LOAD_MORE_LABEL = 'Load more reviews';
  const VERIFIED_ICON_URL =
    'https://cdn.shopify.com/s/files/1/0559/0004/5490/files/vector-varified.svg?v=1788011479';
  const ARROW_ICON_URL =
    'https://cdn.shopify.com/s/files/1/0559/0004/5490/files/vector-arrow.svg?v=1788005193';
  const CHEVRON_SVG =
    '<svg class="m-cr-dropdown__chevron" width="12" height="8" viewBox="0 0 12 8" aria-hidden="true"><path fill="currentColor" d="M1.4.6 6 5.2 10.6.6 12 2 6 8 0 2z"/></svg>';

  /* Theme settings → Reviews can pin the figures (data-rating-override / data-count-override / data-proof-label
     on the section); otherwise the live Judge.me numbers are used. */
  /* Scroll to the reviews themselves (first review card just under whatever is pinned at the top), not the
     section heading, so reviews are actually on screen. Waits briefly for the Judge.me widget to render.
     Optional review uuid: scroll on to that card and flash it. Exposed for the trusted-by badge script. */
  const REVIEW_CARD_SEL = '.jdgm-rev, .jm-review-item';

  function pinnedOffset() {
    const styles = getComputedStyle(document.documentElement);
    let offset = 0;
    if (document.documentElement.classList.contains('announcement-is-stuck')) {
      offset += parseFloat(styles.getPropertyValue('--m-announcement-height')) || 0;
    }
    const tabs = document.querySelector('m-product-tabs-nav');
    if (tabs) offset += parseFloat(styles.getPropertyValue('--ptn-bar-height')) || 0;
    return offset + 12;
  }

  function scrollToEl(el) {
    const top = el.getBoundingClientRect().top + window.scrollY - pinnedOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function scrollToReviews(uuid) {
    const section =
      document.getElementById('reviews') || document.querySelector(SECTION_SEL);
    if (!section) return false;
    const firstCard = () => section.querySelector(REVIEW_CARD_SEL);
    const wanted = () => (uuid ? section.querySelector('[data-review-id="' + uuid + '"]') : null);
    const settle = function (card) {
      scrollToEl(card);
      /* The announcement bar (and product tabs) pin themselves during the scroll, which changes the
         offset; once the smooth scroll has finished, nudge so the card sits just under them. */
      const realign = function () {
        const top = card.getBoundingClientRect().top;
        const want = pinnedOffset();
        if (Math.abs(top - want) > 4) window.scrollBy({ top: top - want, behavior: 'auto' });
      };
      setTimeout(realign, 800);
      setTimeout(realign, 1400);
      if (uuid && card.getAttribute('data-review-id') === uuid) {
        card.classList.add('m-ph-review-flash');
        setTimeout(function () {
          card.classList.remove('m-ph-review-flash');
        }, 2400);
      }
    };
    if (!firstCard()) scrollToEl(section);
    let tries = 0;
    const tick = function () {
      const card = wanted() || (tries >= 12 ? firstCard() : null) || (!uuid ? firstCard() : null);
      if (card) return settle(card);
      if (++tries < 24) setTimeout(tick, 250);
      else if (firstCard()) settle(firstCard());
    };
    tick();
    return true;
  }
  window.bgScrollToReviews = scrollToReviews;

  /* Arriving with #reviews or #review-<uuid> (e.g. from the homepage badge): land on the reviews / that
     review once the page and widget are ready. */
  function landFromHash() {
    var hash = location.hash || '';
    if (hash === '#reviews') return scrollToReviews();
    if (hash.indexOf('#review-') === 0) return scrollToReviews(hash.slice(8));
  }
  if (document.readyState === 'complete') setTimeout(landFromHash, 300);
  else window.addEventListener('load', function () { setTimeout(landFromHash, 300); });

  document.addEventListener(
    'click',
    function (event) {
      const link = event.target && event.target.closest ? event.target.closest('a[href$="#reviews"]') : null;
      if (!link) return;
      const href = link.getAttribute('href') || '';
      if (href !== '#reviews' && href.indexOf(location.pathname + '#reviews') === -1) return;
      if (link.__bgAvatarHandled) return;
      if (scrollToReviews()) event.preventDefault();
    },
    true
  );

  function reviewCountLabel(count, section) {
    const n = Number(String(count == null ? '' : count).replace(/[^\d.]/g, ''));
    if (!n) return '';
    const label = (section && section.getAttribute('data-proof-label')) || 'verified reviews';
    return 'stars based on ' + n.toLocaleString() + ' ' + label;
  }

  function ratingOverride(section, fallback) {
    const v = section && section.getAttribute('data-rating-override');
    return v && v.trim() ? v.trim() : fallback;
  }

  function combinedReviewCount(section, productCount) {
    const override = section && section.getAttribute('data-count-override');
    const o = Number(String(override == null ? '' : override).replace(/[^\d.]/g, ''));
    if (o) return o;
    const all = section && section.getAttribute('data-all-reviews-count');
    const n = Number(String(all == null ? '' : all).replace(/[^\d.]/g, ''));
    if (n) return n;
    return productCount;
  }

  const SORT_LABELS = {
    created_at: 'Latest',
    highest_rating: 'Highest rating',
    lowest_rating: 'Lowest rating',
    with_pictures: 'Only pictures',
    pictures_first: 'Pictures first',
    videos_first: 'Videos first',
    most_helpful: 'Most helpful',
  };

  const RATING_OPTIONS = [
    { value: 'all', label: 'All ratings' },
    { value: '5', label: '5 stars' },
    { value: '4', label: '4 stars' },
    { value: '3', label: '3 stars' },
    { value: '2', label: '2 stars' },
    { value: '1', label: '1 star' },
  ];

  function formatRating(value) {
    const n = typeof value === 'number' ? value : parseFloat(String(value == null ? '' : value).replace(/,/g, ''));
    if (!Number.isFinite(n)) return '';
    return n.toFixed(1);
  }

  function relativeTime(dateInput) {
    const date = new Date(dateInput);
    if (Number.isNaN(date.getTime())) return '';
    const days = Math.max(0, Math.floor((Date.now() - date.getTime()) / 86400000));
    if (days < 1) return 'Today';
    if (days === 1) return '1 day ago';
    if (days < 7) return days + ' days ago';
    const weeks = Math.floor(days / 7);
    if (weeks < 5) return weeks === 1 ? '1 week ago' : weeks + ' weeks ago';
    const months = Math.floor(days / 30);
    if (months < 12) return months === 1 ? '1 month ago' : months + ' months ago';
    const years = Math.floor(days / 365);
    return years === 1 ? '1 year ago' : years + ' years ago';
  }

  function getWidgetData(section) {
    const widget = section.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
    const productId = widget && (widget.getAttribute('data-product-id') || widget.getAttribute('data-id'));
    const store = window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget;
    if (store && productId && store[productId]) return store[productId];
    if (store) {
      const keys = Object.keys(store);
      if (keys.length) return store[keys[0]];
    }
    return null;
  }

  function enhanceSummary(section, data) {
    const header = section.querySelector('.jdgm-rev-widg__header, .jdgm-all-reviews__header');
    const summary = section.querySelector('.jdgm-rev-widg__summary, .jdgm-all-reviews__summary');
    const histogram = section.querySelector('.jdgm-histogram');
    if (!header || !summary) return;

    const allHeader = section.querySelector('.jdgm-all-reviews__header');
    const avg = ratingOverride(
      section,
      (data && data.average_rating) ||
        (allHeader && allHeader.getAttribute('data-average-rating')) ||
        section.querySelector('.jdgm-rev-widg')?.getAttribute('data-average-rating') ||
        ''
    );
    const count = combinedReviewCount(
      section,
      (data && data.number_of_reviews) ||
        (allHeader && allHeader.getAttribute('data-number-of-reviews')) ||
        section.querySelector('.jdgm-rev-widg')?.getAttribute('data-number-of-reviews') ||
        ''
    );

    if (avg && !summary.querySelector('.m-cr-score')) {
      const score = document.createElement('div');
      score.className = 'm-cr-score';
      score.innerHTML =
        '<span class="m-cr-score__value">' +
        formatRating(avg) +
        '</span><span class="m-cr-score__denom">/ 5.0</span>';
      summary.insertBefore(score, summary.firstChild);
    }

    const text = summary.querySelector(
      '.jdgm-rev-widg__summary-text, .jdgm-all-reviews__summary-text'
    );
    if (text && count && !text.getAttribute('data-cr-labelled')) {
      const label = reviewCountLabel(count, section);
      if (label) {
        text.textContent = label;
        text.setAttribute('data-cr-labelled', 'true');
      }
    }

    if (!header.querySelector('.m-cr-summary-split')) {
      const split = document.createElement('div');
      split.className = 'm-cr-summary-split';
      const left = document.createElement('div');
      left.className = 'm-cr-summary-left';
      left.appendChild(summary);
      split.appendChild(left);
      if (histogram) {
        histogram.classList.remove('jdgm-temp-hidden');
        split.appendChild(histogram);
      }
      const title = header.querySelector('.jdgm-rev-widg__title, .jdgm-all-reviews__title');
      if (title && title.nextSibling) {
        header.insertBefore(split, title.nextSibling);
      } else {
        header.insertBefore(split, header.firstChild);
      }
    }

    section.querySelectorAll('.jdgm-histogram__row[data-rating]').forEach(function (row) {
      if (row.querySelector('.m-cr-hist-label')) return;
      const rating = row.getAttribute('data-rating');
      const starWrap = row.querySelector('.jdgm-histogram__star');
      if (!starWrap || !rating) return;
      starWrap.innerHTML =
        '<span class="m-cr-hist-label">' +
        rating +
        '</span><span class="jdgm-star jdgm--on m-cr-hist-star" aria-hidden="true"></span>';
    });
  }

  function isProductShot(link) {
    if (!link) return true;
    if (link.classList.contains('jdgm--loading')) return true;
    if (link.classList.contains('jdgm-rev__product-picture')) return true;
    if (link.querySelector('.jdgm-rev__product-picture, .jdgm-rev__product-image')) return true;
    if (link.closest('.jdgm-rev__product-picture, .jdgm-rev__prod-info-wrapper, .jdgm-rev__prod-link')) return true;
    const img = link.querySelector('img');
    const cls = ((img && img.className) || '') + ' ' + (link.className || '');
    return /product-picture|product-image|product-img/i.test(cls);
  }

  function hasNativePhotoGallery(section) {
    return !!section.querySelector(
      '.jdgm-gallery .jdgm-gallery__thumbnail, .jdgm-gallery__thumbnail-link img, .jm-media-grid__item'
    );
  }

  function enhancePhotoStrip(section, data) {
    const header = section.querySelector('.jdgm-rev-widg__header, .jdgm-all-reviews__header');
    if (!header) return;

    // Judge.me's own gallery opens the photo modal. Our strip was built from product thumbnails and does not.
    if (hasNativePhotoGallery(section)) {
      const injected = header.querySelector('.m-cr-photos');
      if (injected) injected.remove();
      return;
    }

    let existing = header.querySelector('.m-cr-photos');
    if (existing) return;

    const cards = [];

    section.querySelectorAll('.jdgm-rev__pic-link').forEach(function (link) {
        if (isProductShot(link)) return;
        const img = link.querySelector('img');
        const src = (img && (img.getAttribute('src') || img.getAttribute('data-src'))) || '';
        if (!src) return;
        cards.push({
          src: src,
          huge: link.getAttribute('href') || src,
          name: (link.closest('.jdgm-rev')?.querySelector('.jdgm-rev__author')?.textContent || 'Customer').trim(),
          link: link,
        });
    });

    if (!cards.length) return;

    const wrap = document.createElement('div');
    wrap.className = 'm-cr-photos';
    wrap.innerHTML =
      '<p class="m-cr-photos__label">Customer photos (' +
      cards.length +
      ')</p><div class="m-cr-photos__track" role="list"></div>';
    const track = wrap.querySelector('.m-cr-photos__track');

    cards.slice(0, 12).forEach(function (card) {
      const item = document.createElement('button');
      item.type = 'button';
      item.className = 'm-cr-photos__card';
      item.setAttribute('role', 'listitem');
      item.setAttribute('aria-label', 'Open photo from ' + card.name);
      item.innerHTML =
        '<img class="m-cr-photos__img" src="' +
        card.src +
        '" alt="' +
        card.name.replace(/"/g, '&quot;') +
        ' review photo" width="164" height="164" loading="lazy">' +
        '<span class="m-cr-photos__name">' +
        card.name.replace(/</g, '&lt;') +
        '</span>';
      if (card.link) {
        item.addEventListener('click', function () {
          card.link.click();
        });
      }
      track.appendChild(item);
    });

    const sort = header.querySelector('.jdgm-rev-widg__sort-wrapper');
    const histogram = header.querySelector('.jdgm-histogram, .m-cr-summary-split');
    if (sort) {
      header.insertBefore(wrap, sort);
    } else if (histogram && histogram.nextSibling) {
      header.insertBefore(wrap, histogram.nextSibling);
    } else {
      header.appendChild(wrap);
    }
  }

  function layoutLegacyCard(rev) {
    const header = rev.querySelector('.jdgm-rev__header');
    if (!header) return;

    let wrap = header.querySelector(':scope > .m-cr-review-header');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'm-cr-review-header';
      header.insertBefore(wrap, header.firstChild);
    }
    let meta = wrap.querySelector(':scope > .m-cr-review-meta');
    if (!meta) {
      meta = document.createElement('div');
      meta.className = 'm-cr-review-meta';
      wrap.appendChild(meta);
    }

    const profile = rev.querySelector('.jdgm-row-profile') || rev.querySelector('.jdgm-rev__author-wrapper');
    const rating = rev.querySelector('.jdgm-rev__rating');
    const timeEl = rev.querySelector('.jdgm-rev__timestamp');
    if (profile && !wrap.contains(profile)) wrap.insertBefore(profile, meta);
    if (rating && rating.parentElement !== meta) meta.appendChild(rating);
    if (timeEl && timeEl.parentElement !== meta) meta.appendChild(timeEl);

    rev.querySelectorAll('.jdgm-row-rating').forEach(function (row) {
      if (!row.children.length) row.remove();
    });
  }

  function syncHelpfulVotes(rev) {
    const votes = rev.querySelector('.jdgm-rev__votes');
    if (!votes) return;
    votes.querySelectorAll('.m-cr-vote').forEach(function (el) {
      el.remove();
    });
    const native = votes.querySelector('.jdgm-rev__thumb-btn, [class*="thumb"]');
    if (!native || votes.querySelector('.m-cr-helpful-label') || /helpful/i.test(votes.textContent || '')) return;
    const label = document.createElement('span');
    label.className = 'm-cr-helpful-label';
    label.textContent = 'Was this helpful?';
    votes.insertBefore(label, votes.firstChild);
  }

  function enhanceReviews(section) {
    section.querySelectorAll('.jdgm-rev').forEach(function (rev) {
      syncHelpfulVotes(rev);
      layoutLegacyCard(rev);
      if (rev.classList.contains('m-cr-rev--ready')) return;
      rev.classList.add('m-cr-rev--ready');

      const header = rev.querySelector('.jdgm-rev__header');

      let badge = rev.querySelector('.jdgm-rev__buyer-badge');
      if (badge) {
        if (!badge.textContent.trim() || /verified/i.test(badge.textContent)) {
          badge.textContent = 'Verified Customer';
        }
      } else if (rev.getAttribute('data-verified-buyer') === 'true' && header) {
        const wrap = document.createElement('span');
        wrap.className = 'jdgm-rev__buyer-badge-wrapper';
        wrap.innerHTML = '<span class="jdgm-rev__buyer-badge">Verified Customer</span>';
        const profile = header.querySelector('.jdgm-row-profile, .jdgm-rev__author-wrapper') || header;
        profile.appendChild(wrap);
        badge = wrap.querySelector('.jdgm-rev__buyer-badge');
      }
      const legacyBadgeWrap = rev.querySelector('.jdgm-rev__buyer-badge-wrapper');
      const verified =
        rev.getAttribute('data-verified-buyer') === 'true' ||
        !!(badge && badge.textContent.trim());
      if (legacyBadgeWrap && verified) {
        ensureVerifiedIcon(legacyBadgeWrap);
      } else if (legacyBadgeWrap) {
        legacyBadgeWrap.remove();
      }

      const time = rev.querySelector('.jdgm-rev__timestamp');
      if (time && !time.getAttribute('data-cr-dated')) {
        const raw = time.getAttribute('datetime') || time.getAttribute('data-content') || time.textContent || '';
        const label = parseJmDate(raw);
        if (label) {
          time.textContent = label;
          time.classList.remove('jdgm-spinner');
          time.setAttribute('data-cr-dated', 'true');
        }
      }

      rev.querySelectorAll('.jdgm-rev__pic-img').forEach(function (img) {
        const src = img.getAttribute('data-src') || img.getAttribute('src');
        if (src && !img.getAttribute('src')) img.setAttribute('src', src);
        img.removeAttribute('loading');
        img.setAttribute('loading', 'lazy');
      });
    });
  }

  function parseJmDate(text) {
    const m = String(text || '')
      .trim()
      .match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/);
    if (!m) return relativeTime(text);
    let year = parseInt(m[3], 10);
    if (year < 100) year += 2000;
    const day = parseInt(m[1], 10);
    const month = parseInt(m[2], 10) - 1;
    return relativeTime(new Date(year, month, day));
  }

  function injectSummaryStars(avgDisplay, average) {
    if (!avgDisplay || avgDisplay.querySelector('.m-cr-summary-stars')) return;
    const rating = Math.max(0, Math.min(5, Number(average) || 0));
    const filled = Math.round(rating);
    const row = document.createElement('div');
    row.className = 'm-cr-summary-stars';
    row.setAttribute('role', 'img');
    row.setAttribute('aria-label', rating.toFixed(1) + ' out of 5 stars');
    let html = '';
    for (let i = 0; i < 5; i++) {
      const on = i < filled;
      html +=
        '<span class="m-cr-summary-stars__icon' +
        (on ? '' : ' m-cr-summary-stars__icon--off') +
        '" aria-hidden="true">★</span>';
    }
    row.innerHTML = html;

    const cluster = avgDisplay.querySelector('.jm-cluster');
    if (cluster) {
      cluster.insertAdjacentElement('afterend', row);
    } else {
      avgDisplay.appendChild(row);
    }

    const countEl = avgDisplay.querySelector('.m-cr-revamp-count');
    if (countEl) {
      row.insertAdjacentElement('afterend', countEl);
    }
  }

  const LOAD_MORE_SEL =
    '.jm-load-more-pagination .jm-button, .jm-pagination-controls .jm-button, .jdgm-paginate__load-more';

  function countReviews(section) {
    return section.querySelectorAll('.jdgm-rev, .jm-review-item').length;
  }

  /* Spinner inside the Load more button from tap until the next batch of reviews is in. Judge.me re-renders
     the button after loading, which drops the state on its own; the count check and a timeout cover the rest. */
  function stopLoadMore(btn) {
    if (!btn) return;
    btn.classList.remove('m-cr-loading');
    btn.removeAttribute('aria-busy');
    if (btn.__crLoadTimer) {
      clearTimeout(btn.__crLoadTimer);
      btn.__crLoadTimer = null;
    }
  }

  function startLoadMore(btn, section) {
    if (btn.classList.contains('m-cr-loading')) return;
    btn.__crCount = countReviews(section);
    /* Spinner is pure CSS (::after) — no inserted node, so Judge.me's re-render cannot orphan it. */
    btn.classList.add('m-cr-loading');
    btn.setAttribute('aria-busy', 'true');
    btn.__crLoadTimer = setTimeout(function () {
      stopLoadMore(btn);
    }, 10000);
  }

  function syncLoadMoreState(section) {
    // Sweep any spinner nodes left over from the earlier implementation.
    section.querySelectorAll('.m-cr-btn-spinner').forEach(function (el) {
      el.remove();
    });
    section.querySelectorAll(LOAD_MORE_SEL).forEach(function (btn) {
      if (!btn.classList.contains('m-cr-loading')) return;
      if (countReviews(section) > (btn.__crCount || 0)) stopLoadMore(btn);
    });
  }

  /* Top up the first render (Judge.me pages by 5) to data-initial-reviews by pulling the next pages
     automatically, one after another. The user's own taps stay at 5 per tap. */
  function autoloadInitialReviews(section) {
    const target = parseInt(section.getAttribute('data-initial-reviews'), 10) || 0;
    if (!target || section.getAttribute('data-cr-autoload')) return;
    const btn = section.querySelector(LOAD_MORE_SEL);
    if (!btn || countReviews(section) === 0) return;
    if (countReviews(section) >= target) {
      section.setAttribute('data-cr-autoload', 'done');
      return;
    }
    /* Never compete with the initial page load: wait for the load event, then for the section to come
       within about a screen of the viewport. */
    if (document.readyState !== 'complete') {
      if (!section.__crAutoloadOnLoad) {
        section.__crAutoloadOnLoad = true;
        window.addEventListener('load', function () {
          setTimeout(function () { autoloadInitialReviews(section); }, 250);
        }, { once: true });
      }
      return;
    }
    if ('IntersectionObserver' in window && !section.__crAutoloadIO) {
      section.__crAutoloadIO = true;
      const io = new IntersectionObserver(
        function (entries) {
          if (!entries.some(function (e) { return e.isIntersecting; })) return;
          io.disconnect();
          section.__crAutoloadIO = 'fired';
          run();
        },
        { rootMargin: '100% 0px' }
      );
      io.observe(section);
      return;
    }
    if (section.__crAutoloadIO !== 'fired') return;
    run();

    function run() {
    if (section.getAttribute('data-cr-autoload')) return;
    section.setAttribute('data-cr-autoload', 'running');
    section.classList.add('m-cr-autoloading');
    const startedAt = Date.now();

    const step = function () {
      const count = countReviews(section);
      const button = section.querySelector(LOAD_MORE_SEL);
      if (count >= target || !button || Date.now() - startedAt > 20000) {
        section.setAttribute('data-cr-autoload', 'done');
        section.classList.remove('m-cr-autoloading');
        return;
      }
      button.click();
      const before = count;
      const waitStart = Date.now();
      const poll = function () {
        const now = countReviews(section);
        const stillThere = section.querySelector(LOAD_MORE_SEL);
        if (now > before || !stillThere) return step();
        if (Date.now() - waitStart > 8000) {
          section.setAttribute('data-cr-autoload', 'done');
          section.classList.remove('m-cr-autoloading');
          return;
        }
        setTimeout(poll, 120);
      };
      setTimeout(poll, 120);
    };
    step();
    }
  }

  function renameLoadMore(section) {
    syncLoadMoreState(section);
    section.querySelectorAll(LOAD_MORE_SEL).forEach(function (btn) {
      const text = (btn.textContent || '').trim();
      if (!text) return;
      if (/show more|load more/i.test(text) && text !== LOAD_MORE_LABEL) {
        btn.textContent = LOAD_MORE_LABEL;
      }
      if (btn.getAttribute('aria-label') && /show more|load more/i.test(btn.getAttribute('aria-label'))) {
        btn.setAttribute('aria-label', LOAD_MORE_LABEL);
      }
      if (!btn.getAttribute('data-cr-loader')) {
        btn.setAttribute('data-cr-loader', 'true');
        btn.addEventListener('click', function () {
          startLoadMore(btn, section);
        });
      }
    });
  }

  function ensureVerifiedIcon(badgeRoot) {
    if (!badgeRoot || badgeRoot.querySelector('.m-cr-verified-icon')) return;
    const img = document.createElement('img');
    img.className = 'm-cr-verified-icon';
    img.src = VERIFIED_ICON_URL;
    img.alt = '';
    img.width = 14;
    img.height = 18;
    img.setAttribute('aria-hidden', 'true');
    img.decoding = 'async';
    badgeRoot.insertBefore(img, badgeRoot.firstChild);
  }

  function findReviewDateEl(item) {
    const details = item.querySelector('.jm-reviewer-info__details');
    if (!details) return null;
    const texts = details.querySelectorAll('.jm-text');
    for (let i = 0; i < texts.length; i++) {
      const el = texts[i];
      if (el.classList.contains('jm-reviewer-info__name')) continue;
      if (el.classList.contains('jm-verified-buyer-badge__text')) continue;
      if (el.closest('.jm-verified-buyer-badge')) continue;
      const t = (el.textContent || '').trim();
      if (!t) continue;
      if (
        /ago|today|yesterday|\d{1,2}\/\d{1,2}\/\d{2,4}/i.test(t) ||
        el.classList.contains('m-cr-review-date')
      ) {
        return el;
      }
    }
    return null;
  }

  function layoutReviewMeta(item) {
    if (item.querySelector('.m-cr-review-meta')) return;

    const content = item.querySelector('.jm-review-item__content');
    const stars = item.querySelector('.jm-star-rating');
    const reviewer = item.querySelector('.jm-reviewer-info');
    const dateEl = findReviewDateEl(item);
    if (!content || !stars || !reviewer) return;

    const header = document.createElement('div');
    header.className = 'm-cr-review-header';

    const meta = document.createElement('div');
    meta.className = 'm-cr-review-meta';

    const starsCluster = stars.closest('.jm-cluster') || stars;
    meta.appendChild(starsCluster);

    if (dateEl) {
      dateEl.classList.add('m-cr-review-date');
      const label = parseJmDate(dateEl.textContent);
      if (label) dateEl.textContent = label;
      meta.appendChild(dateEl);
    }

    header.appendChild(reviewer);
    header.appendChild(meta);
    content.insertBefore(header, content.firstChild);
  }

  function syncHistogramActive(section, rating) {
    section.querySelectorAll('.m-cr-revamp-histogram__row').forEach(function (row) {
      row.classList.toggle(
        'm-cr-revamp-histogram__row--active',
        rating !== 'all' && row.getAttribute('data-rating') === String(rating)
      );
    });
  }

  function syncRatingDropdown(section, rating) {
    const dd = section.querySelector('[data-cr-dropdown="rating"]');
    if (!dd) return;
    const label =
      (RATING_OPTIONS.find(function (o) {
        return o.value === String(rating);
      }) || {}).label || 'All ratings';
    const valueEl = dd.querySelector('.m-cr-dropdown__value');
    if (valueEl) valueEl.textContent = label;
    dd.querySelectorAll('.m-cr-dropdown__option').forEach(function (opt) {
      opt.toggleAttribute('aria-selected', opt.getAttribute('data-value') === String(rating));
    });
  }

  function ensureJmRatingControls(section) {
    const btn = section.querySelector('.jm-custom-answer-filter');
    if (!section.querySelector('input[name="rating-filter"]')) {
      if (!btn) return false;
      if (btn.getAttribute('aria-expanded') !== 'true') btn.click();
    }
    const panel = section.querySelector('.jm-filter-panel');
    if (panel) {
      panel.setAttribute('aria-hidden', 'true');
      panel.classList.add('m-cr-jm-filter-panel--sr');
    }
    if (btn) {
      btn.setAttribute('aria-hidden', 'true');
      btn.tabIndex = -1;
    }
    return !!section.querySelector('input[name="rating-filter"]');
  }

  function setNativeRatingFilter(section, value) {
    section.setAttribute('data-cr-rating-filter', value || 'all');
    syncHistogramActive(section, value || 'all');
    syncRatingDropdown(section, value || 'all');

    // Drive Judge.me’s real rating radios (refetches reviews) instead of hiding cards
    ensureJmRatingControls(section);

    if (!value || value === 'all') {
      const clear = section.querySelector('.jm-filter-panel__clear-btn');
      const checked = section.querySelector('input[name="rating-filter"]:checked');
      if (clear && checked) {
        clear.classList.remove('jm-filter-panel__clear-btn--hidden');
        clear.removeAttribute('aria-hidden');
        clear.tabIndex = 0;
        clear.click();
      } else if (checked) {
        checked.checked = false;
        checked.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    const input = section.querySelector('input[name="rating-filter"][value="' + value + '"]');
    if (!input) return;
    if (input.checked) return;
    const label = input.closest('label');
    if (label) label.click();
    else {
      input.checked = true;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.click();
    }
  }

  function setNativeSort(section, value) {
    const select = section.querySelector('.jm-sort-filter__select, select.jdgm-sort-dropdown');
    if (!select || !value) return;
    if (select.value === value) return;
    select.value = value;
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function closeAllDropdowns(section) {
    section.querySelectorAll('.m-cr-dropdown.is-open').forEach(function (dd) {
      dd.classList.remove('is-open');
      const btn = dd.querySelector('.m-cr-dropdown__trigger');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function buildDropdown(opts) {
    const wrap = document.createElement('div');
    wrap.className = 'm-cr-dropdown';
    wrap.setAttribute('data-cr-dropdown', opts.id);

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'm-cr-dropdown__trigger';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML =
      '<span class="m-cr-dropdown__prefix">' +
      opts.prefix +
      '</span><span class="m-cr-dropdown__value">' +
      opts.valueLabel +
      '</span>' +
      CHEVRON_SVG;

    const menu = document.createElement('ul');
    menu.className = 'm-cr-dropdown__menu';
    menu.setAttribute('role', 'listbox');
    menu.hidden = true;

    opts.options.forEach(function (opt) {
      const li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.className = 'm-cr-dropdown__option';
      li.setAttribute('data-value', opt.value);
      li.textContent = opt.label;
      if (opt.value === opts.value) li.setAttribute('aria-selected', 'true');
      menu.appendChild(li);
    });

    wrap.appendChild(btn);
    wrap.appendChild(menu);

    btn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      const section = wrap.closest(SECTION_SEL);
      const wasOpen = wrap.classList.contains('is-open');
      if (section) closeAllDropdowns(section);
      if (!wasOpen) {
        wrap.classList.add('is-open');
        menu.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
      } else {
        menu.hidden = true;
      }
    });

    menu.addEventListener('click', function (event) {
      const option = event.target.closest('.m-cr-dropdown__option');
      if (!option) return;
      event.preventDefault();
      event.stopPropagation();
      const value = option.getAttribute('data-value');
      const label = option.textContent;
      wrap.querySelectorAll('.m-cr-dropdown__option').forEach(function (el) {
        el.removeAttribute('aria-selected');
      });
      option.setAttribute('aria-selected', 'true');
      const valueEl = wrap.querySelector('.m-cr-dropdown__value');
      if (valueEl) valueEl.textContent = label;
      wrap.classList.remove('is-open');
      menu.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      if (typeof opts.onChange === 'function') opts.onChange(value, label);
    });

    return wrap;
  }

  function mountCustomControls(section) {
    if (section.querySelector('.m-cr-controls')) return;

    const nativeBar =
      section.querySelector('.jm-review-widget-minimal-header__filters') ||
      section.querySelector('.jm-filters');
    if (!nativeBar) return;

    const sortSelect = section.querySelector('.jm-sort-filter__select, select.jdgm-sort-dropdown');
    const sortOptions = [];
    if (sortSelect) {
      [...sortSelect.options].forEach(function (opt) {
        sortOptions.push({
          value: opt.value,
          label: SORT_LABELS[opt.value] || opt.textContent.trim(),
        });
      });
    } else {
      Object.keys(SORT_LABELS).forEach(function (key) {
        sortOptions.push({ value: key, label: SORT_LABELS[key] });
      });
    }

    const currentSort = (sortSelect && sortSelect.value) || 'created_at';
    const currentSortLabel =
      SORT_LABELS[currentSort] ||
      (sortSelect && sortSelect.selectedOptions[0] && sortSelect.selectedOptions[0].textContent.trim()) ||
      'Latest';

    const controls = document.createElement('div');
    controls.className = 'm-cr-controls';

    const sortDd = buildDropdown({
      id: 'sort',
      prefix: 'Sort by:',
      value: currentSort,
      valueLabel: currentSortLabel,
      options: sortOptions,
      onChange: function (value) {
        setNativeSort(section, value);
      },
    });

    const ratingDd = buildDropdown({
      id: 'rating',
      prefix: 'Rating:',
      value: 'all',
      valueLabel: 'All ratings',
      options: RATING_OPTIONS,
      onChange: function (value) {
        setNativeRatingFilter(section, value);
      },
    });

    controls.appendChild(sortDd);
    controls.appendChild(ratingDd);

    nativeBar.classList.add('m-cr-native-filters--hidden');
    nativeBar.insertAdjacentElement('beforebegin', controls);

    // Prefetch JM rating radios into the DOM (panel stays visually hidden)
    ensureJmRatingControls(section);

    if (!section._crDropdownDocBound) {
      section._crDropdownDocBound = true;
      document.addEventListener('click', function (event) {
        if (!section.contains(event.target)) {
          closeAllDropdowns(section);
          section.querySelectorAll('.m-cr-dropdown__menu').forEach(function (menu) {
            menu.hidden = true;
          });
          return;
        }
        if (!event.target.closest('.m-cr-dropdown')) {
          closeAllDropdowns(section);
          section.querySelectorAll('.m-cr-dropdown__menu').forEach(function (menu) {
            menu.hidden = true;
          });
        }
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeAllDropdowns(section);
          section.querySelectorAll('.m-cr-dropdown__menu').forEach(function (menu) {
            menu.hidden = true;
          });
        }
      });
    }
  }

  function wireHistogramRatingFilter(section) {
    section.querySelectorAll('.m-cr-revamp-histogram__row').forEach(function (row) {
      if (row.getAttribute('data-cr-hist-bound')) return;
      row.setAttribute('data-cr-hist-bound', 'true');
      const rating = row.getAttribute('data-rating');
      if (!rating) return;
      row.setAttribute('role', 'button');
      row.setAttribute('tabindex', '0');
      row.addEventListener('click', function () {
        const current = section.getAttribute('data-cr-rating-filter') || 'all';
        const next = current === rating ? 'all' : rating;
        setNativeRatingFilter(section, next);
      });
    });
  }

  function styleJudgemeLightbox(modal) {
    if (!modal || modal.getAttribute('data-cr-lightbox-styled')) return;
    modal.setAttribute('data-cr-lightbox-styled', 'true');
    modal.classList.add('m-cr-jm-lightbox');

    // Close → circular dark pill with × (matches video testimonials)
    const close = modal.querySelector('.jm-indicator__close');
    if (close && !close.querySelector('.m-cr-jm-lightbox__close-x')) {
      close.innerHTML = '<span class="m-cr-jm-lightbox__close-x" aria-hidden="true">&times;</span>';
    }

    // Prev/next → homepage arrow asset
    const prev = modal.querySelector('.jm-navigation__previous');
    const next = modal.querySelector('.jm-navigation__next');
    if (prev && !prev.querySelector('img.m-cr-jm-lightbox__arrow')) {
      prev.innerHTML =
        '<img class="m-cr-jm-lightbox__arrow m-cr-jm-lightbox__arrow--prev" src="' +
        ARROW_ICON_URL +
        '" alt="" width="40" height="40" decoding="async">';
    }
    if (next && !next.querySelector('img.m-cr-jm-lightbox__arrow')) {
      next.innerHTML =
        '<img class="m-cr-jm-lightbox__arrow" src="' +
        ARROW_ICON_URL +
        '" alt="" width="40" height="40" decoding="async">';
    }
  }

  function enhanceJudgemeLightbox() {
    const modal = document.querySelector('.jdgm-modal.jdgm-widget-revamp');
    if (!modal) return;
    const isOpen =
      getComputedStyle(modal).display !== 'none' &&
      !!modal.querySelector('.jm-indicator__close, .jm-navigation__previous, .jm-content');
    if (!isOpen) return;

    styleJudgemeLightbox(modal);

    modal.querySelectorAll('.jm-verified-buyer-badge').forEach(function (badge) {
      ensureVerifiedIcon(badge);
      const text = badge.querySelector('.jm-verified-buyer-badge__text');
      if (text) {
        const t = (text.textContent || '').trim();
        if (!t || /^verified(\s+buyer)?$/i.test(t)) text.textContent = 'Verified Customer';
      }
    });
  }

  function enhanceRevamp(section, data) {
    const avgDisplay = section.querySelector('.jm-average-rating-display');
    const avgWrap = avgDisplay && avgDisplay.querySelector('.jm-cluster');
    const scoreEl = avgWrap && avgWrap.querySelector('.jm-text');
    if (scoreEl) {
      const formatted = formatRating(ratingOverride(section, (data && data.average_rating) || scoreEl.textContent));
      if (formatted) scoreEl.textContent = formatted;
    }
    if (avgWrap && !avgWrap.querySelector('.m-cr-revamp-denom')) {
      const countEl = scoreEl && scoreEl.nextElementSibling;
      if (scoreEl) {
        const denom = document.createElement('span');
        denom.className = 'm-cr-revamp-denom';
        denom.textContent = '/ 5.0';
        scoreEl.insertAdjacentElement('afterend', denom);
      }
      if (countEl && countEl.classList.contains('jm-text')) {
        countEl.classList.add('m-cr-revamp-count');
        const n = combinedReviewCount(
          section,
          (data && data.number_of_reviews) || countEl.textContent.replace(/\D/g, '')
        );
        const label = reviewCountLabel(n, section);
        if (label) countEl.textContent = label;
      }
    }

    const average = ratingOverride(section, (data && data.average_rating) ||
      (avgWrap && avgWrap.querySelector('.jm-text') && parseFloat(avgWrap.querySelector('.jm-text').textContent)) ||
      0);
    if (avgDisplay) injectSummaryStars(avgDisplay, average);

    // Figma order: summary → photos → controls → reviews
    const filterBar =
      section.querySelector('.jm-review-widget-minimal-header__filters') ||
      section.querySelector('.jm-filters');
    if (filterBar && !filterBar.classList.contains('m-cr-filters--placed')) {
      filterBar.classList.add('m-cr-filters--placed');
      const media = section.querySelector('.jm-media-preview');
      const reviewList =
        section.querySelector('.jm-review-widget__body') ||
        section.querySelector('.jm-reviews-list') ||
        section.querySelector('.jm-review-item')?.parentElement;
      if (media && media.parentElement) {
        media.insertAdjacentElement('afterend', filterBar);
      } else if (reviewList && reviewList.parentElement) {
        reviewList.parentElement.insertBefore(filterBar, reviewList);
      }
    }
    mountCustomControls(section);

    const header = section.querySelector('.jm-review-widget__header');
    if (header && data && !header.querySelector('.m-cr-summary-split')) {
      const histogram = data.histogram || data.rating_histogram || data.rating_distribution;
      let rows = [];
      if (Array.isArray(histogram)) {
        rows = histogram;
      } else if (histogram && typeof histogram === 'object') {
        rows = [5, 4, 3, 2, 1].map(function (rating) {
          const pct =
            histogram[rating] ||
            histogram[String(rating)] ||
            (histogram['rating_' + rating] != null ? histogram['rating_' + rating] : null);
          return { rating: rating, percentage: pct };
        });
      }

      if (!rows.length && data) {
        const total = Number(data.number_of_reviews) || 0;
        const counts = [
          data.five_star_reviews || data['5_star'] || data.rating_5,
          data.four_star_reviews || data['4_star'] || data.rating_4,
          data.three_star_reviews || data['3_star'] || data.rating_3,
          data.two_star_reviews || data['2_star'] || data.rating_2,
          data.one_star_reviews || data['1_star'] || data.rating_1,
        ];
        if (counts.some(function (c) {
          return c != null;
        }) && total) {
          rows = [5, 4, 3, 2, 1].map(function (rating, i) {
            const count = Number(counts[i]) || 0;
            return { rating: rating, percentage: Math.round((count / total) * 100) };
          });
        }
      }

      if (rows.length) {
        const split = document.createElement('div');
        split.className = 'm-cr-summary-split';
        const left = document.createElement('div');
        left.className = 'm-cr-summary-left';
        if (avgDisplay && avgDisplay.parentElement) {
          left.appendChild(avgDisplay);
        }
        split.appendChild(left);
        const hist = document.createElement('div');
        hist.className = 'm-cr-revamp-histogram';
        rows.forEach(function (row) {
          const rating = row.rating || row.stars;
          const pct = Number(row.percentage != null ? row.percentage : row.percent) || 0;
          if (!rating) return;
          const el = document.createElement('div');
          el.className = 'm-cr-revamp-histogram__row';
          el.setAttribute('data-rating', String(rating));
          el.innerHTML =
            '<span class="m-cr-revamp-histogram__label">' +
            rating +
            ' <span class="m-cr-revamp-histogram__star" aria-hidden="true">★</span></span><div class="m-cr-revamp-histogram__track"><div class="m-cr-revamp-histogram__fill" style="width:' +
            pct +
            '%"></div></div><span class="m-cr-revamp-histogram__pct">' +
            pct +
            '%</span>';
          hist.appendChild(el);
        });
        if (hist.children.length) {
          split.appendChild(hist);
          const titleRow = header.querySelector('.jm-cluster');
          if (titleRow && titleRow.parentElement) {
            titleRow.parentElement.insertBefore(split, titleRow.nextSibling);
          } else {
            header.appendChild(split);
          }
        }
      }
    }

    wireHistogramRatingFilter(section);

    section.querySelectorAll('.jm-review-item').forEach(function (item) {
      const badgeWrap = item.querySelector('.jm-verified-buyer-badge');
      const badge = item.querySelector('.jm-verified-buyer-badge__text');
      if (badge) {
        const t = (badge.textContent || '').trim();
        if (!t || /^verified(\s+buyer)?$/i.test(t)) {
          badge.textContent = 'Verified Customer';
        }
      }
      if (badgeWrap) ensureVerifiedIcon(badgeWrap);

      layoutReviewMeta(item);

      if (item.classList.contains('m-cr-rev--ready')) return;
      item.classList.add('m-cr-rev--ready');

      const dateEl = item.querySelector('.m-cr-review-date') || findReviewDateEl(item);
      if (dateEl) {
        dateEl.classList.add('m-cr-review-date');
        const label = parseJmDate(dateEl.textContent);
        if (label) dateEl.textContent = label;
      }
    });

    syncHistogramActive(section, section.getAttribute('data-cr-rating-filter') || 'all');
    renameLoadMore(section);
    enhanceJudgemeLightbox();
  }

  function enhanceSection(section) {
    if (!section) return;

    const isRevamp = !!section.querySelector(
      '.jdgm-widget-revamp, .jm-review-widget, .jm-review-widget--minimal-header'
    );

    if (section.classList.contains(ENHANCED)) {
      if (isRevamp) {
        enhanceRevamp(section, getWidgetData(section));
      } else {
        enhancePhotoStrip(section, getWidgetData(section));
        enhanceReviews(section);
      }
      renameLoadMore(section);
      return;
    }
    const widgetRoot = section.querySelector(
      '.jdgm-rev-widg, .jdgm-all-reviews-page, .jdgm-all-reviews-widget, .jdgm-all-reviews-widget-v2025, .jdgm-widget, .jm-review-widget'
    );
    if (!widgetRoot) return;

    const data = getWidgetData(section);
    if (isRevamp) {
      enhanceRevamp(section, data);
    } else {
      enhanceSummary(section, data);
      enhancePhotoStrip(section, data);
      enhanceReviews(section);
    }
    renameLoadMore(section);
    section.classList.add(ENHANCED);
  }

  function refreshSection(section) {
    if (
      !section.querySelector(
        '.jdgm-rev-widg, .jdgm-all-reviews-page, .jdgm-all-reviews-widget, .jdgm-all-reviews-widget-v2025, .jdgm-widget, .jm-review-widget'
      )
    ) {
      return;
    }
    enhanceSection(section);
  }

  let reviewsObserver = null;
  let applyingReviews = false;
  let reviewsApplyQueued = false;

  function watchReviewTargets() {
    if (!reviewsObserver) return;
    document.querySelectorAll(SECTION_SEL).forEach(function (section) {
      reviewsObserver.observe(section, { childList: true, subtree: true });
    });
    const modal = document.querySelector('.jdgm-modal.jdgm-widget-revamp');
    if (modal) reviewsObserver.observe(modal, { childList: true, subtree: true });
  }

  function applyReviewEnhancements() {
    if (applyingReviews) return;
    applyingReviews = true;
    if (reviewsObserver) reviewsObserver.disconnect();
    try {
      document.querySelectorAll(SECTION_SEL).forEach(refreshSection);
      document.querySelectorAll(SECTION_SEL).forEach(autoloadInitialReviews);
      enhanceJudgemeLightbox();
    } finally {
      applyingReviews = false;
      watchReviewTargets();
    }
  }

  function queueReviewEnhancements() {
    if (reviewsApplyQueued) return;
    reviewsApplyQueued = true;
    requestAnimationFrame(function () {
      reviewsApplyQueued = false;
      if (applyingReviews) {
        queueReviewEnhancements();
        return;
      }
      applyReviewEnhancements();
    });
  }

  function observe() {
    reviewsObserver = new MutationObserver(function () {
      if (applyingReviews) return;
      queueReviewEnhancements();
    });
    applyReviewEnhancements();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  document.addEventListener('click', function (event) {
    const target = event.target;
    if (!target || !target.closest) return;
    if (!target.closest(SECTION_SEL) && !target.closest('.jdgm-modal')) return;
    queueReviewEnhancements();
  });

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target && event.target.querySelector
      ? event.target.closest(SECTION_SEL) || event.target.querySelector(SECTION_SEL)
      : null;
    if (section) section.classList.remove(ENHANCED);
    applyReviewEnhancements();
  });
})();
